/* eslint-disable no-param-reassign */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface NewTagInSectionModalState {
    isOpen: boolean;

    data: {
        documentId: number;

        chapterId: number;

        sectionId: number;
    } | null;
}

export interface NewTagInSectionModalDispatchParams {
    documentId: number;

    chapterId: number;

    sectionId: number;
}

const initialState: NewTagInSectionModalState = {
    isOpen: false,
    data: null,
};

export const newTagInSectionModalSlice = createSlice({
    name: 'new-tag-in-section-modal',
    initialState,
    reducers: {
        open(state: NewTagInSectionModalState, action: PayloadAction<NewTagInSectionModalDispatchParams>) {
            state.isOpen = true;
            state.data = action.payload;
        },
        close(state: NewTagInSectionModalState) {
            state.isOpen = false;
            state.data = null;
        },
    },
});
